// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__3uCLI","content":"Layout_content__Vib45","loading":"Layout_loading__jOQ9b","loadingDots":"Layout_loadingDots__cseX7","bounce":"Layout_bounce__DuAMU"};